<template>
  <!-- Phase 2 - Waitlist OTP Access Control (#24) -->
  <b-modal
    v-model="dialog"
    title="Verify Identity to View Position"
    hide-footer
    centered
    size="sm"
    no-close-on-backdrop
  >
    <div v-if="step === 'send'">
      <p class="mb-3">
        To view the specific patient position, an OTP will be sent to the
        registered mobile number of UID <strong>{{ uid }}</strong>.
      </p>
      <div class="d-flex justify-content-end">
        <b-button variant="outline-secondary" class="me-2" @click="close"
          >Cancel</b-button
        >
        <b-button variant="primary" :disabled="isSending" @click="sendOTP"
          >Send OTP</b-button
        >
      </div>
    </div>
    <div v-else-if="step === 'verify'">
      <p class="mb-2">
        OTP sent to mobile ending with <strong>{{ phoneLast4 }}</strong>
      </p>
      <form-wrapper @submit="verifyOTP">
        <input-field
          v-model.trim="otpCode"
          label="Enter OTP"
          rules="required|min:4|max:6"
          type="number"
        ></input-field>
        <div class="d-flex justify-content-between align-items-center mt-2">
          <b-button
            variant="link"
            size="sm"
            :disabled="resendTimer > 0"
            @click="sendOTP"
          >
            {{ resendTimer > 0 ? `Resend in ${resendTimer}s` : "Resend OTP" }}
          </b-button>
          <div>
            <b-button variant="outline-secondary" class="me-2" @click="close"
              >Cancel</b-button
            >
            <b-button variant="success" type="submit" :disabled="isVerifying"
              >Verify</b-button
            >
          </div>
        </div>
      </form-wrapper>
    </div>
  </b-modal>
</template>

<script>
import userService from "../../assets/services/user.service";
export default {
  props: {
    uid: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dialog: false,
      step: "send",
      otpCode: "",
      phoneLast4: "",
      isSending: false,
      isVerifying: false,
      resendTimer: 0,
      timerInterval: null,
    };
  },
  methods: {
    open() {
      this.step = "send";
      this.otpCode = "";
      this.phoneLast4 = "";
      this.resendTimer = 0;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.clearTimer();
    },
    clearTimer() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
        this.timerInterval = null;
      }
    },
    startResendTimer() {
      this.resendTimer = 60;
      this.clearTimer();
      this.timerInterval = setInterval(() => {
        this.resendTimer--;
        if (this.resendTimer <= 0) {
          this.clearTimer();
        }
      }, 1000);
    },
    async sendOTP() {
      const vm = this;
      try {
        vm.isSending = true;
        let { data } = await userService.waitlistSendOTP({
          recipient_registration_id: vm.uid,
        });
        vm.isSending = false;
        if (!data.status) {
          vm.$alert.show(data.msg);
          return;
        }
        vm.phoneLast4 = data.phone_last4;
        vm.step = "verify";
        vm.startResendTimer();
      } catch (error) {
        vm.isSending = false;
        vm.$alert.show(error.message);
      }
    },
    async verifyOTP() {
      const vm = this;
      try {
        vm.isVerifying = true;
        let { data } = await userService.waitlistVerifyOTP({
          recipient_registration_id: vm.uid,
          otp_code: vm.otpCode,
        });
        vm.isVerifying = false;
        if (!data.status) {
          vm.$alert.show(data.msg);
          return;
        }
        vm.dialog = false;
        vm.clearTimer();
        vm.$emit("verified", data.list);
      } catch (error) {
        vm.isVerifying = false;
        vm.$alert.show(error.message);
      }
    },
  },
  beforeDestroy() {
    this.clearTimer();
  },
};
</script>
